import type { Container } from 'pixi.js';
import { onLayoutPopulated } from '../populate';
import { centerElements } from '../../../game/utils/centerElements';

export function layoutCenterSPL(): void {
  onLayoutPopulated.connect(
    (layout: {
      root: Container;
      // eslint-disable-next-line @typescript-eslint/naming-convention
      center_SPL?: Container[];
      // eslint-disable-next-line @typescript-eslint/naming-convention
      centerChildren_SPL?: (Container & { data?: { centerChildrenPadding?: number; root?: Container } })[];
    }) => {
      if (layout.center_SPL) {
        centerElements(layout.center_SPL, 0);
        return;
      }

      if (layout.centerChildren_SPL) {
        layout.centerChildren_SPL.forEach(
          (container: Container & { data?: { centerChildrenPadding?: number }; root?: Container }) => {
            centerElements((container.root ?? container).children, container?.data?.centerChildrenPadding ?? 0);
          },
        );
      }
    },
  );
}
